var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-wrapper position-fixed full-y",
      class: [_vm.open ? "draw-show" : "draw-hide"],
      attrs: { id: "menuShow" },
      on: { mouseleave: _vm.onMouseLeave },
    },
    [
      _c("Search"),
      _c(
        "div",
        { staticClass: "menu-category full-y padding-left-10" },
        [
          _c("MenuLogo"),
          _c(
            "div",
            { staticClass: "menu-list" },
            _vm._l(_vm.menus, function (item, index) {
              return _c(
                "div",
                { key: item.id, staticClass: "padding-y-6" },
                [
                  _c("MenuItem", {
                    attrs: {
                      active: index === _vm.activeIndex,
                      title: item.name,
                      selectedIcon: item.selectedIcon,
                      unselectedIcon: item.unselectedIcon,
                      id: index === 0 ? "commonMenu" : "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setActiveIndex(index)
                      },
                    },
                  }),
                  _vm.keyWords
                    ? _c(
                        "div",
                        {
                          staticClass: "sub-menu search-menu position-absolute",
                        },
                        [
                          _vm.resultList.length
                            ? _c(
                                "div",
                                { staticClass: "padding-x-15" },
                                _vm._l(_vm.resultList, function (sub) {
                                  return _c(
                                    "div",
                                    { key: sub.id },
                                    [
                                      _c("Title", {
                                        attrs: {
                                          path: sub.path,
                                          title: sub.name,
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "flex-start flex-wrap" },
                                        _vm._l(sub.children, function (grand) {
                                          return _c("NavLink", {
                                            key: grand.id,
                                            attrs: {
                                              path: grand.path,
                                              title: grand.name,
                                              item: grand,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-center margin-top-40 color-999",
                                },
                                [_vm._v("未搜索到相关菜单")]
                              ),
                        ]
                      )
                    : [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index === _vm.activeIndex,
                                expression: "index === activeIndex",
                              },
                            ],
                            staticClass: "sub-menu position-absolute",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "padding-x-15" },
                              _vm._l(item.children, function (sub) {
                                return _c(
                                  "div",
                                  { key: sub.id },
                                  [
                                    _c("Title", {
                                      attrs: {
                                        path: sub.path,
                                        title: sub.name,
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-start flex-wrap margin-left-5",
                                      },
                                      _vm._l(sub.children, function (grand) {
                                        return _c("NavLink", {
                                          key: grand.id,
                                          attrs: {
                                            path: grand.path,
                                            title: grand.name,
                                            item: grand,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }